(function () {
  function initPricingSection(sectionEl) {
    if (sectionEl.dataset.zhPricingInit === '1') return;
    sectionEl.dataset.zhPricingInit = '1';

    var cards = Array.from(sectionEl.querySelectorAll('.zh-pricing__card'));
    var dots = Array.from(sectionEl.querySelectorAll('.zh-pricing__dot'));
    var cardsWrap = sectionEl.querySelector('.zh-pricing__cards');
    if (!cardsWrap || cards.length === 0) return;

    /* Card selection (click/keyboard) */
    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('active');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('active');
      card.setAttribute('aria-pressed', 'true');
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    /* Mobile slider */
    var current = 0;
    var startX = 0;
    var dragging = false;

    function isMobile() { return window.innerWidth <= 750; }

    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index >= cards.length) index = cards.length - 1;
      current = index;
      cardsWrap.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (!isMobile()) return;
        goToSlide(Number(dot.getAttribute('data-index')));
      });
    });

    cardsWrap.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      dragging = true;
      startX = e.clientX;
    });
    cardsWrap.addEventListener('pointerup', function (e) {
      if (!dragging || !isMobile()) return;
      dragging = false;
      var diff = e.clientX - startX;
      if (Math.abs(diff) > 50) {
        goToSlide(diff < 0 ? current + 1 : current - 1);
      }
    });
    cardsWrap.addEventListener('pointercancel', function () { dragging = false; });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        cardsWrap.style.transform = '';
        current = 0;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === 0); });
      }
    });

    /* Product popup */
    var popup = sectionEl.querySelector('[data-zh-popup]');
    if (popup) {
      var popupList = popup.querySelector('[data-zh-popup-list]');

      function openPopup(triggerEl) {
        var template = triggerEl.querySelector('.zh-pricing__popup-data');
        if (!template || !popupList) return;
        popupList.innerHTML = '';
        popupList.appendChild(template.content.cloneNode(true));
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closePopup() {
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      sectionEl.querySelectorAll('[data-zh-popup-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          openPopup(trigger);
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPopup(trigger);
          }
        });
      });

      popup.querySelectorAll('[data-zh-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) closePopup();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.zh-pricing').forEach(initPricingSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-initialize when Shopify re-renders the section in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector('.zh-pricing');
    if (sectionEl) initPricingSection(sectionEl);
  });
})();
